/**
 * 动态路由过滤
 * desc:传入的resourceData要为有效的资源树，黑名单等资源，请先移除后生成最终有效资源树数据在做匹配
 * 使用方式：
const lastRoute = this.getSubMenuList(lastResourceData) //最终动态路由树
*/

// 资源打平
function getResourceMapFunc(resourceData) {
  const resourceMap = {}
  const getResourceMap = (item, parent) => {
    if (item) {
      const levels = [...((parent && parent.levels) || [])]
      parent && levels.push(parent.resourceKey)
      item.levels = [...levels]
      resourceMap[item.resourceKey] = {
        ...item,
        levels,
      }
      if (item.children && item.children.length) {
        item.children.forEach((subItem) => {
          getResourceMap(subItem, item)
        })
      }
    }
  }
  resourceData.forEach((item) => {
    getResourceMap(item)
  })
  return resourceMap
}
function setSubMenuList(dataList, resourceMap = {}) {
  const getList = (arr, parentItem = null) => {
    const newArr = []
    arr.forEach((item) => {
      const { name, children } = item
      const resourceItem = resourceMap[name]
      if (resourceItem) {
        if (item.meta) {
          item.meta.levels = resourceItem.levels || []
          item.meta.title = resourceItem.resourceName || item.meta.title
        } else {
          item.meta = {
            levels: resourceItem.levels || [],
            title: resourceItem.resourceName,
          }
        }
        item.meta.marking = [] // 新增默认值，避免无权限判断报错
      }
      if (item.noPermission) {
        if (children && children.length) {
          const newChild = getList(children, { ...item })
          item.children = newChild
          if (newChild && newChild.length) {
            newArr.push(item)
          }
        } else if (parentItem.noPermission) {
          newArr.push(item)
        } else if (resourceMap[parentItem.name]) {
          // 要把对应的按钮资源加到这个页面上
          newArr.push(item)
        } else {
          // console.log('ldllld1', item.name)
        }
      } else if (children && children.length) {
        const newChild = getList(children, { ...item })
        item.children = newChild
        item.meta = item.meta || {}
        const marking = [
          ...((resourceItem && resourceItem.btnList) || []),
          ...(children || []),
        ].map((citem) => citem.resourceKey || citem.name)
        item.meta.marking = marking
        if (newChild && newChild.length) {
          newArr.push(item)
        } else if (resourceItem) {
          newArr.push(item)
        }
      } else if (resourceItem && !(children && children.length)) {
        item.meta = item.meta || {}
        if (resourceItem.btnList && resourceItem.btnList.length) {
          const marking = resourceItem.btnList.map((btnItem) => {
            return btnItem.resourceKey
          })
          item.meta.marking = marking
        }
        newArr.push(item)
      }
    })
    return newArr
  }
  const newList = getList(dataList)
  return newList
}
export default function (OriRouterModules, resourceData) {
  const resourceMap = getResourceMapFunc(resourceData)
  const routerModules = [...OriRouterModules]
  const dynamicRoute = setSubMenuList(routerModules, resourceMap)
  return dynamicRoute
}
